import { useCallback, useEffect, useState } from 'react';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import { getProvidersSelector } from 'redux/selectors';
import { updateProviderConfirmOrder } from 'redux/actions/providers';
import { PROVIDER_AUTO_CONFIRM_ORDER, PROVIDER_NOT_CONFIRM_ORDER } from 'constants/providerStatuses';

const autoConfirmDineInSchema = yup.object().shape({
  orderConfirm: yup.object().shape({
    dine_in: yup.object().shape({
      autoConfirm: yup.boolean(),
    }),
  }),
});

const autoConfirmDineInDefaultValue = {
  orderConfirm: {
    dine_in: {
      autoConfirm: false,
    },
  },
};

const useDineInAutoConfirm = (items, srv) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { providerId } = useSelector(getProvidersSelector);

  const autoConfirmDineIn = useForm({
    defaultValues: autoConfirmDineInDefaultValue,
    mode: 'all',
    resolver: yupResolver(autoConfirmDineInSchema),
  });

  useEffect(() => {
    const findProviderConfirm = items.find((item) => item?.srv === srv);
    if (findProviderConfirm) {
      if (findProviderConfirm?.orderConfirm?.dine_in) {
        autoConfirmDineIn.reset({
          orderConfirm: {
            dine_in: {
              autoConfirm: findProviderConfirm?.orderConfirm?.dine_in?.autoConfirm,
            },
          },
        });
      }
    }
  }, [items, srv]);

  const handleSubmit = () => {};

  const handleConfirm = useCallback((event) => {
    const { checked } = event.target;
    setLoading(true);
    dispatch(
      updateProviderConfirmOrder(
        {
          id: providerId,
          confirmOrder: checked ? PROVIDER_AUTO_CONFIRM_ORDER : PROVIDER_NOT_CONFIRM_ORDER,
          provider: srv,
          orderConfirm: {
            dine_in: {
              autoConfirm: checked,
            },
          },
        },
        false
      )
    )
      .then(() => {})
      .finally(() => setLoading(false));
  }, []);

  return {
    autoConfirmDineIn,
    handleSubmit,
    handleConfirm,
    loading,
  };
};

export default useDineInAutoConfirm;
